// Add a line per page; remove a line to hide it there.
const NAVBAR_PAGE_OBJECTS = {
  "/mtp": "2708863e-92f8-468a-a7f7-e7da08597902",
  "/investmentStreams": "cde58a34-5938-4e09-b3fb-fcf2a1deebd3",
  "/sp": "dfe1e87a-ab34-4353-8208-5f4505b6b3ea",
  "/spp": "4cdacab7-493c-4da5-a512-f4c75d6f3f38",
  "/expertEvaluation": "f07fb49d-92c2-4727-99f8-f8b415c7191e",
  "/pipDetails": "f07fb49d-92c2-4727-99f8-f8b415c7191e",
  "/programDetails": "f07fb49d-92c2-4727-99f8-f8b415c7191e",
  "/sectoralEvaluation": "b8e0295a-f481-47aa-8258-c9ef2471c268",
};

// Resolve the object ID for a given pathname (supports sub-routes).
export function getNavbarObjectId(pathname) {
  if (NAVBAR_PAGE_OBJECTS[pathname]) return NAVBAR_PAGE_OBJECTS[pathname];
  const match = Object.keys(NAVBAR_PAGE_OBJECTS).find(
    (path) => pathname === path || pathname.startsWith(path + "/")
  );
  return match ? NAVBAR_PAGE_OBJECTS[match] : null;
}

export default NAVBAR_PAGE_OBJECTS;